import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiZap, FiShield, FiTrendingUp, FiUsers, FiCheck, FiArrowRight, FiMessageSquare } = FiIcons;

const SolutionSection = () => {
  const handleCTAClick = () => {
    window.open('https://app.noem.ai/cb/growthshop', '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-slate-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
            Plug the Leaks and Turn Visitors into Customers,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-teal-500">
              24/7.
            </span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-4">
            Introducing the <span className="font-bold text-emerald-600">Handvantage AI Sales Assistant</span>. It's not just another chatbot. It's a fully-trained, proactive sales professional that we build and deploy for you.
          </p>

          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            It integrates seamlessly with your store to engage customers, answer their questions instantly, and guide them to a purchase. Our AI Assistant becomes your best salesperson—one that never sleeps, never takes a break, and is an expert on every single one of your products.
          </p>
        </motion.div>

        {/* Side-by-Side Comparison */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16"
        >
          {/* Without AI */}
          <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-3xl p-8 border-2 border-red-200">
            <div className="text-center mb-6">
              <div className="text-4xl mb-3">😞</div>
              <h3 className="text-2xl font-bold text-red-600">Without AI Assistant</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <p className="text-gray-700">Customer: "What's your return policy?"</p>
                <p className="text-gray-400 text-sm mt-2 italic">*No response... customer leaves*</p>
              </div>
              <div className="text-center">
                <div className="text-red-600 font-bold text-xl">❌ Sale Lost</div>
                <div className="text-gray-600 text-sm mt-1">Frustrated customer gone forever</div>
              </div>
            </div>
          </div>

          {/* With AI */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 border-2 border-emerald-200">
            <div className="text-center mb-6">
              <div className="text-4xl mb-3">🎉</div>
              <h3 className="text-2xl font-bold text-emerald-600">With AI Assistant</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-4 shadow-sm">
                <p className="text-gray-700">Customer: "What's your return policy?"</p>
                <p className="text-emerald-600 font-medium mt-2">AI: "We offer 30-day returns! Need help with anything else?"</p>
              </div>
              <div className="text-center">
                <div className="text-emerald-600 font-bold text-xl">✅ Sale Closed</div>
                <div className="text-gray-600 text-sm mt-1">Happy customer converts instantly</div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-center"
        >
          <motion.button
            onClick={handleCTAClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-black py-4 px-8 rounded-2xl text-lg shadow-2xl flex items-center gap-2 mx-auto cursor-pointer"
          >
            <span>SEE IT IN ACTION - BOOK FREE DEMO</span>
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionSection;